import { styled } from '@mui/material';
import React from 'react';
import { AnimationDot } from '../Animation/AnimationDot.js';
import '../../icons/abstract/AbstractArcIcon.js';
import '../../icons/AddCircleIcon.js';
import '../../icons/AddCircleOutlineIcon.js';
import '../../icons/ArrowCircleRightIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/BoltIcon.js';
import '../../icons/BookmarkStarIcon.js';
import '../../icons/CalendarIcon.js';
import '../../icons/CancelIcon.js';
import '../../icons/ChatIcon.js';
import '../../icons/CheckCircleIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronLeftIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CloseIcon.js';
import '../../icons/MenuIcon.js';
import '../../icons/NotificationActiveIcon.js';
import '../../icons/PaperPlaneIcon.js';
import '../../icons/PendingIcon.js';
import '../../icons/PersonIcon.js';
import '../../icons/PlayCircleIcon.js';
import '../../icons/RemoveCircleIcon.js';
import '../../icons/SearchIcon.js';
import '../../icons/SellIcon.js';
import { ShoppingBagIcon } from '../../icons/ShoppingBagIcon.js';
import '../../icons/SmartphoneIcon.js';
import '../../icons/StarIcon.js';
import '../../icons/StarOutlineIcon.js';
import '../../icons/SuccessCheckCircleIcon.js';
import '../../icons/TuneIcon.js';
import '../../icons/FourPointStarIcon.js';

var TextButton = styled('div')(function (_a) {
    var textColor = _a.textColor, fontSize = _a.fontSize, fontWeight = _a.fontWeight;
    return ({
        color: textColor,
        fontSize: fontSize,
        fontWeight: fontWeight,
        cursor: 'pointer',
    });
});
var CartCountContainer = styled('div')(function (_a) {
    var bottomOffset = _a.bottomOffset, fontSize = _a.fontSize;
    return ({
        position: 'absolute',
        bottom: +bottomOffset,
        fontSize: +fontSize,
        fontWeight: 600,
        lineHeight: 1.4,
    });
});
var CartCount = function (_a) {
    var count = _a.count, countNumber = _a.countNumber, bottomOffset = _a.bottomOffset, fontSize = _a.fontSize;
    if (!count || !countNumber)
        return null;
    return (React.createElement(CartCountContainer, { bottomOffset: bottomOffset, fontSize: fontSize }, count));
};
var CustomDtcBagButton = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
    var cartCount = _a.cartCount, styleData = _a.styleData, mobile = _a.mobile, handleClick = _a.handleClick, dtc = _a.dtc;
    var paramName = mobile ? 'bagButtonMobile' : 'bagButton';
    var customImage = dtc
        ? (_c = (_b = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _b === void 0 ? void 0 : _b.bagButton) === null || _c === void 0 ? void 0 : _c.dtcImageUrl
        : (_e = (_d = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _d === void 0 ? void 0 : _d.bagButton) === null || _e === void 0 ? void 0 : _e.imageUrl;
    var customSize = (_h = (_g = (_f = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _f === void 0 ? void 0 : _f.bagButton) === null || _g === void 0 ? void 0 : _g.size) !== null && _h !== void 0 ? _h : 25;
    var textButton = !!((_k = (_j = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _j === void 0 ? void 0 : _j[paramName]) === null || _k === void 0 ? void 0 : _k.textButton);
    var text = (_m = (_l = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _l === void 0 ? void 0 : _l[paramName]) === null || _m === void 0 ? void 0 : _m.text;
    var textColor = (_p = (_o = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _o === void 0 ? void 0 : _o[paramName]) === null || _p === void 0 ? void 0 : _p.textFontColor;
    var fontSize = (_r = (_q = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _q === void 0 ? void 0 : _q[paramName]) === null || _r === void 0 ? void 0 : _r.textFontSize;
    var fontWeight = (_t = (_s = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _s === void 0 ? void 0 : _s[paramName]) === null || _t === void 0 ? void 0 : _t.textFontWeight;
    var animationDot = !!((_v = (_u = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _u === void 0 ? void 0 : _u[paramName]) === null || _v === void 0 ? void 0 : _v.animationDot);
    var dotTopOffset = ((_x = (_w = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _w === void 0 ? void 0 : _w[paramName]) === null || _x === void 0 ? void 0 : _x.animationDotYOffset) || 0;
    var dotRightOffset = ((_z = (_y = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _y === void 0 ? void 0 : _y[paramName]) === null || _z === void 0 ? void 0 : _z.animationDotXOffset) || 0;
    var dotColor = ((_1 = (_0 = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _0 === void 0 ? void 0 : _0[paramName]) === null || _1 === void 0 ? void 0 : _1.animationDotColor) || '#ffffff';
    var dotSize = ((_3 = (_2 = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _2 === void 0 ? void 0 : _2[paramName]) === null || _3 === void 0 ? void 0 : _3.animationDotSize) || 8;
    var countNumber = (_5 = (_4 = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _4 === void 0 ? void 0 : _4[paramName]) === null || _5 === void 0 ? void 0 : _5.countNumber;
    var countNumberYOffset = ((_7 = (_6 = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _6 === void 0 ? void 0 : _6[paramName]) === null || _7 === void 0 ? void 0 : _7.countNumberYOffset) || 4;
    var countNumberSize = ((_9 = (_8 = styleData === null || styleData === void 0 ? void 0 : styleData.inpageCheckoutComponent) === null || _8 === void 0 ? void 0 : _8[paramName]) === null || _9 === void 0 ? void 0 : _9.countNumberSize) || 8;
    return (React.createElement("div", { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } }, textButton ? (React.createElement(TextButton, { onClick: handleClick, fontSize: fontSize ? +fontSize : 20, fontWeight: fontWeight || 'normal', textColor: textColor || '#ffffff' },
        React.createElement("span", null, cartCount ? "".concat(text, " (").concat(cartCount, ")") : text))) : (React.createElement("div", { onClick: handleClick, style: {
            cursor: 'pointer',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: +customSize,
            height: +customSize,
        } },
        cartCount ? (React.createElement(AnimationDot, { animationDot: animationDot, dotSize: dotSize, topOffset: dotTopOffset, rightOffset: dotRightOffset, dotColor: dotColor })) : null,
        React.createElement(CartCount, { count: cartCount, countNumber: countNumber, bottomOffset: countNumberYOffset, fontSize: countNumberSize }),
        customImage ? (React.createElement("img", { src: customImage, alt: "Bag Icon", style: {
                width: +customSize,
                height: +customSize,
                objectFit: 'contain',
            } })) : (React.createElement(ShoppingBagIcon, { sx: {
                fontSize: +customSize,
            } }))))));
};

export { CustomDtcBagButton };
//# sourceMappingURL=CustomDtcBagButton.js.map
